'use client';

import { Button, ButtonSizes, ButtonTypes } from '@actr/ui/src/components/_atoms/button';
import { Text } from '@actr/ui/src/components/_atoms/text';
import { ContentBlock } from '@actr/ui/src/components/content-block';
import { Map, Placemark, YMaps } from '@iminside/react-yandex-maps';
import React, { memo } from 'react';

import { SeoAirportMap } from '@/services/models/avia/airports';

import * as Styled from './style.css';

export type AirportMapProps = SeoAirportMap;

const AirportMap: React.FC<AirportMapProps> = props => {
  const { title, list } = props;
  const coordinates = [
    list.coordinates.lat,
    list.coordinates.lng,
  ];

  function handleOpenYandex() {
    const href = `https://maps.yandex.ru/?text=${list.coordinates.lat}+${list.coordinates.lng}`;
    window.open(href);
  }

  return (
    <ContentBlock className={Styled.ContentBlock} id="map">
      <Text tagName="h3" font="title.x2l">{title}</Text>
      <YMaps query={{ lang: 'ru_RU' }}>
        <div className={Styled.MapContainer}>
          <Map width={772} height={316} defaultState={{ center: coordinates, zoom: 12 }}>
            <Placemark defaultGeometry={coordinates} defaultOptions={{ preset: 'islands#blueAirportIcon' }} />
          </Map>
        </div>
      </YMaps>
      <Button
        className={Styled.Button}
        size={ButtonSizes.M}
        buttonType={ButtonTypes.SECONDARY}
        onClick={handleOpenYandex}>
        Открыть в картах
      </Button>
    </ContentBlock>
  );
};

export default memo(AirportMap);
